/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElTabs as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/tabs/style/css';
import { ElTabPane as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/tab-pane/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logoWhite.png';
const _withScopeId = n => (_pushScopeId("data-v-ce8765b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"left-wrapper\" data-v-ce8765b8><div class=\"logo\" data-v-ce8765b8><img height=\"100px\" src=\"" + _imports_0 + "\" alt=\"\" data-v-ce8765b8></div><div class=\"title\" data-v-ce8765b8>极简易用的手游发行SDK</div><div class=\"sub-title\" data-v-ce8765b8>安全 可靠 快速 高效</div></div>", 1);
const _hoisted_3 = {
  class: "right-wrapper"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ch"
}, "登录", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "en"
}, "SIGN IN", -1));
const _hoisted_7 = {
  class: "width100 flex items-center justify-between"
};
const _hoisted_8 = {
  class: "copy-right"
};
import { User, Lock, Cellphone, ChatDotSquare } from '@element-plus/icons-vue';
import { ElForm, ElMessage } from 'element-plus';
import { apiGetSmsCode } from '@/api/user';
import { Md5 } from 'ts-md5/dist/md5';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';
import { usePermissionStore } from '@/store/modules/permission';
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {
    const SDK_NAME = process.env.VUE_APP_SDK_NAME;
    const SDK_NAME2 = process.env.VUE_APP_SDK_NAME2;
    const form = ref({
      UserName: '',
      Password: '',
      Phone: '',
      PhoneCode: ''
    });
    let loading = ref(false);
    const state = reactive({
      time: 60,
      loginBtn: false,
      loginType: 0,
      smsSendBtn: false
    });
    let customActiveKey = ref('account');
    const formLogin = ref();
    const rules = {
      UserName: {
        required: true,
        message: '请输入手机号/邮箱',
        trigger: 'blur'
      },
      Password: {
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      },
      Phone: [{
        required: true,
        message: '请输入正确的手机号',
        trigger: 'blur'
      }, {
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'change'
      }],
      PhoneCode: {
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }
    };
    const {
      login,
      getUserInfo
    } = useUserStore();
    const {
      getGameInfo,
      setGameInfo
    } = useAppStore();
    const {
      generateRoutes,
      addErrorRoute
    } = usePermissionStore();
    const router = useRouter();
    // 登录
    const handleSubmit = () => {
      // loading.value = true;
      formLogin.value.validate(valid => {
        if (valid) {
          const params = customActiveKey.value === 'account' ? {
            UserName: form.value.UserName,
            Password: Md5.hashStr(form.value.Password).toString(),
            Type: 1
          } : {
            UserName: form.value.Phone,
            PhoneCode: form.value.PhoneCode,
            Type: 2
          };
          login(params).then(res => {
            if (res.code === 0) {
              getUserInfo('reload').then(info => {
                generateRoutes(info.Permissions).then(routes => {
                  if (routes.length) {
                    routes.forEach(item => {
                      router.addRoute('Entry', item);
                    });
                  }
                  addErrorRoute();
                  if (info.LastGameId) {
                    getGameInfo(info.LastGameId).then(res => {
                      // router.push('/home');
                      if (res.code === 0) {
                        setGameInfo(res.data);
                      }
                      router.push('/home');
                    });
                  } else {
                    router.push('/home');
                  }
                });
              });
            }
          });
        } else {
          console.log('error submit!');
          return false;
        }
      });
    };
    // 获取验证码
    const getCaptcha = () => {
      if (!form.value.Phone) {
        ElMessage.warning('请输入手机号');
      } else {
        if (state.smsSendBtn) return;
        state.smsSendBtn = true;
        apiGetSmsCode({
          Phone: form.value.Phone,
          Type: 3
        }).then(res => {
          console.log(res);
          state.smsSendBtn = true;
          let timer = setInterval(() => {
            state.time--;
            if (state.time === 0) {
              state.time = 60;
              state.smsSendBtn = false;
              clearInterval(timer);
            }
          }, 1000);
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = __unplugin_components_0;
      const _component_el_tabs = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "欢迎来到" + _toDisplayString(_unref(SDK_NAME2)), 1), _createVNode(_unref(ElForm), {
        class: "login-form",
        ref_key: "formLogin",
        ref: formLogin,
        rules: rules,
        model: _unref(form)
      }, {
        default: _withCtx(() => [_hoisted_5, _hoisted_6, _createVNode(_component_el_tabs, {
          modelValue: _unref(customActiveKey),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(customActiveKey) ? customActiveKey.value = $event : customActiveKey = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "账号登录",
            name: "account"
          }), _createVNode(_component_el_tab_pane, {
            label: "手机号登录",
            name: "phone"
          })]),
          _: 1
        }, 8, ["modelValue"]), _unref(customActiveKey) === 'account' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_form_item, {
          prop: "UserName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).UserName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).UserName = $event),
            placeholder: "手机号/用户名",
            clearable: "",
            "prefix-icon": _unref(User)
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "Password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).Password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).Password = $event),
            type: "password",
            placeholder: "密码",
            clearable: "",
            "prefix-icon": _unref(Lock)
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_el_form_item, {
          prop: "Phone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).Phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).Phone = $event),
            placeholder: "手机号",
            clearable: "",
            "prefix-icon": _unref(Cellphone)
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "PhoneCode"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
            modelValue: _unref(form).PhoneCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).PhoneCode = $event),
            type: "number",
            placeholder: "验证码",
            clearable: "",
            "prefix-icon": _unref(ChatDotSquare)
          }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_component_el_button, {
            type: "primary",
            class: "marginL30",
            onClick: getCaptcha,
            disabled: _unref(state).smsSendBtn,
            style: {
              "height": "40px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(!_unref(state).smsSendBtn && '获取验证码' || _unref(state).time + ' s'), 1)]),
            _: 1
          }, 8, ["disabled"])])]),
          _: 1
        })], 64)), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            class: "width100",
            style: {
              "height": "43px",
              "font-size": "18px"
            },
            onClick: handleSubmit,
            loading: _unref(loading)
          }, {
            default: _withCtx(() => [_createTextVNode("登录")]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_8, "CopyRight ©2023 " + _toDisplayString(_unref(SDK_NAME)), 1)])]);
    };
  }
});